<template>
  <Modal
    class="export-modal"
    title="Export Short Term Contracts Report"
  >
    <div>
      <InputDatePicker
        v-model="handleDateRange"
        clearable
        placeholder="Select Report date"
      />
    </div>
    <template #buttons="{ close }">
      <a
        class="q-mr-md text-black"
        href="#"
        @click.prevent="close"
      >
        Cancel
      </a>
      <QBtn
        class="no-shadow bg-primary bold q-py-smd text-white"
        label="Export"
        @click="save"
      />
    </template>
  </Modal>
</template>

<script>
import InputDatePicker from "shared/components/base/InputDatePicker.vue";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "ExportShortTermContractsReportModal",
  components: {
    Modal,
    InputDatePicker,
  },
  emits: ["confirm"],
  data() {
    return {
      date: null,
    };
  },
  computed: {
    handleDateRange: {
      get() {
        return this.date;
      },
      set(val) {
        this.date = val;
      },
    },
  },
  methods: {
    save() {
      this.$dialog({
        theme: "danger",
        title: "Are you sure?",
        message:
          "Report will list all contracts that are active on given date and have lass than 12 months duration.",
        persistent: true,
        confirmLabel: "Proceed",
      }).onOk(() => {
        this.$emit("confirm", this.date);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.export-modal {
  z-index: 1500 !important;
}
</style>
